import React from 'react';
import { ContextProvider } from '../../../../../../base';
import { ChatDetailContextValue } from './chatDetailInterface';

export function createChatDetailContext(): ContextProvider<ChatDetailContextValue> {
    const Context = React.createContext<ChatDetailContextValue | null>(null);
    return {
        useContext() {
            const context = React.useContext(Context);
            if (!context) {
                throw new Error(
                    'useChatDetailContext must be used within a ChatDetailContextProvider'
                );
            }
            return context;
        },
        Provider(props) {
            return (
                <Context.Provider value={props.value}>{props.children}</Context.Provider>
            );
        },
    };
}
